export type CliTributos = Readonly<{
  val_red_social: number;

  per_aliq_cbs: number;
  per_red_cbs: number;

  per_aliq_ibs_est: number;
  per_red_ibs: number;
  per_aliq_ibs_mun: number;
}>;

export type CliTributosCalculado = {
  val_bc_ibs_cbs: number;
  val_cbs: number;
  val_ibs_est: number;
  val_ibs_mun: number;
};

const roundTo = (value: number, decimals = 2): number => {
  const factor = 10 ** decimals;
  const safe = Number.isFinite(value) ? value : 0;
  return Math.round((safe + Number.EPSILON) * factor) / factor;
};

const calcularValorPorAliquota = (
  aliquotaPct: number,
  reducaoPct: number,
  base: number,
): number => {
  if (aliquotaPct <= 0) return 0;

  const aliquotaEfetiva =
    reducaoPct > 0
      ? aliquotaPct - roundTo(aliquotaPct * (reducaoPct / 100), 2)
      : aliquotaPct;

  return roundTo(base * (aliquotaEfetiva / 100), 2);
};

export const calculaImpostosIbsCbs = (
  cli: CliTributos,
  vValBcIbsCbs: number,
  vValIcms: number,
  vValPisCofins: number,
  codIbsCbs: number,
): CliTributosCalculado => {
  if (codIbsCbs <= 0)
    return { val_bc_ibs_cbs: 0, val_cbs: 0, val_ibs_est: 0, val_ibs_mun: 0 };

  const val_bc_ibs_cbs =
    vValBcIbsCbs - cli.val_red_social - vValIcms - vValPisCofins;

  const val_cbs = calcularValorPorAliquota(
    cli.per_aliq_cbs,
    cli.per_red_cbs,
    val_bc_ibs_cbs,
  );

  const val_ibs_est = calcularValorPorAliquota(
    cli.per_aliq_ibs_est,
    cli.per_red_ibs,
    val_bc_ibs_cbs,
  );

  const val_ibs_mun = calcularValorPorAliquota(
    cli.per_aliq_ibs_mun,
    cli.per_red_ibs,
    val_bc_ibs_cbs,
  );

  return { val_bc_ibs_cbs, val_cbs, val_ibs_est, val_ibs_mun };
};
